import React, {useState} from 'react';
import {View} from 'react-native';
import {Button, Card, Input, ListItem, Switch} from '@rneui/themed';
import {observer} from 'mobx-react-lite';

import ContentView from '../../../components/ui-controls/layout/ContentView';
import Text from '../../../components/ui-controls/Text';
import config from '../../../config';
import {AppRoute} from '../../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {useStores} from '../../../stores/use-stores';
import {testDeepLink} from '../../../utils/onesignal';

const DeveloperSettingsScreen = observer(
  ({navigation: _navigation}: RouteNavigatorScreenProps<AppRoute.DEVELOPER_SETTINGS>) => {
    const {settingsStore} = useStores();
    const [linkPath, setLinkPath] = useState('promotions/current');

    return (
      <ContentView testID="exclusive-offer-detail-screen">
        <ListItem bottomDivider>
          <ListItem.Content>
            <Text>Show App Development Shop</Text>
          </ListItem.Content>

          <Switch
            value={settingsStore.showAppDevelopmentShop}
            onValueChange={value => {
              settingsStore.setShowAppDevelopmentShop(value);
            }}
          />
        </ListItem>

        <Card>
          <Card.Title>Test Deep Linking</Card.Title>
          <Card.Divider />
          <Input label="Link Path" value={linkPath} onChangeText={setLinkPath} />
          <View style={{flexDirection: 'column', gap: 8}}>
            <Button
              title={
                <LinkButtonTitle
                  title="As Universal Link"
                  description={`https://${config.WHITE_LABEL_ID}-brand-dev.lmg-bw.au/${linkPath}`}
                />
              }
              onPress={() =>
                testDeepLink(`https://${config.WHITE_LABEL_ID}-brand-dev.lmg-bw.au/${linkPath}`)
              }
              size="sm"
            />
            <Button
              title={
                <LinkButtonTitle
                  title="As Deep Link"
                  description={`${config.WHITE_LABEL_ID}://${linkPath}`}
                />
              }
              onPress={() => testDeepLink(`${config.WHITE_LABEL_ID}://${linkPath}`)}
              size="sm"
            />
          </View>
        </Card>
      </ContentView>
    );
  },
);

const LinkButtonTitle = ({title, description}: {title: string; description: string}) => (
  <View style={{flexDirection: 'column', alignItems: 'center'}}>
    <Text style={{fontSize: 18, color: 'white'}}>{title}</Text>
    <Text style={{fontSize: 12, color: 'white'}}>{description}</Text>
  </View>
);

export default DeveloperSettingsScreen;
